'use strict';
/**
 * User Helper (wdUserHelper.js).
 * User Helper.
 *
 * @author rsweeney@webduct.com <rsweeney@webduct.com>
 * @copyright 2018 Webduct Systems Inc.
 *
 * @version
 * 1.0.0 LIBENV-1 Initialize environment library
 *
 */
angular.module('wd.helper.users', [])
    .factory('wdUserHelper',
        function () {

            // User Cookie Adapter
            var cookieAdapter = new WebductCookieAdapter(Cookies);

            // User
            return new WebductUsers(cookieAdapter);

        });
// EOF